:host {
    box-sizing: border-box;
    height: auto;
    width: 100%;

    * {
        box-sizing: border-box;
    }

    .hide {
        display: none !important;
    }

    .wrapper {
        display: flex;
        position: relative;
        width: 100%;
        overflow: hidden;

        border-radius: var(--padding2) var(--padding1);

        .image-loading,
        .image-retry {
            font-family: 'Lato-Light';
        }

        .image-loading {
            position: absolute;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .image-retry {
            display: flex;
            min-width: 100%;
            min-height: 100%;
            justify-content: center;
            align-items: center;
            text-align: center;
        }

        .avatar {
            position: relative;
            width: 100%;
            // max-width: var(--default-hgt-img-background);
            min-height: 90px;
            max-height: 220px;
            object-fit: cover;
            height: auto;
            z-index: 1;
        }
    }

}